const ADD_ITEM = "ADD_ITEM";
const REMOVE_ITEM = "REMOVE_ITEM";
const SET_TOTAL_PRICE = "SET_TOTAL_PRICE";
const SET_ITEMS = "SET_ITEMS";
const UPDATE_QUANTITY = "UPDATE_QUANTITY";
const CLEAR_CART = "CLEAR_CART";

export const addItemToCart = (data) => ({
  type: ADD_ITEM,
  payload: data,
});

export const removeItemFromCart = (itemId) => ({
  type: REMOVE_ITEM,
  payload: itemId,
});

export const updateQuantityt = (itemId, quantity) => ({
  type: UPDATE_QUANTITY,
  payload: {
    id: itemId,
    quantity: quantity,
  },
});

export const updatePrice = (data) => ({
  type: SET_TOTAL_PRICE,
  payload: data
    .filter((i) => i.available === true)
    .reduce((acc, value) => {
      return acc + value.price * value.quantity;
    }, 0),
});

export const setItems = (data) => ({
  type: "SET_ITEMS",
  payload: data,
});

export const clearCartItems = () => ({
  type: "CLEAR_CART",
});

export default (state, action) => {
  switch (action.type) {
    case ADD_ITEM: {
      return {
        ...state,
        items: [...state.items, action.payload],
      };
    }

    case REMOVE_ITEM: {
      const itemIndex = state.items.findIndex((ie) => ie.itemId === action.payload);

      return {
        ...state,
        items: [...state.items.slice(0, itemIndex), ...state.items.slice(itemIndex + 1)],
      };
    }

    case UPDATE_QUANTITY: {
      return {
        ...state,
        items: state.items.map((item) =>
          item.itemId === action.payload.id
            ? { ...item, quantity: action.payload.quantity }
            : item
        ),
      };
    }

    case SET_TOTAL_PRICE: {
      return {
        ...state,
        totalPrice: action.payload,
      };
    }

    case SET_ITEMS: {
      return {
        ...state,
        items: action.payload,
      };
    }

    case CLEAR_CART: {
      return {
        ...state,
        items: [],
        totalPrice: 0,
      };
    }

    default:
      return state;
  }
};
